import React, { useState, useEffect } from 'react';
import { Clock, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useLanguage } from '../context/LanguageContext';

const API = process.env.REACT_APP_BACKEND_URL;

let cachedStatus = null;
let lastFetch = 0;

export function usePortalStatus() {
  const [status, setStatus] = useState(cachedStatus || {});

  useEffect(() => {
    const now = Date.now();
    if (cachedStatus && now - lastFetch < 60000) {
      setStatus(cachedStatus);
      return;
    }
    axios.get(`${API}/api/portals/status`).then(r => {
      cachedStatus = r.data;
      lastFetch = Date.now();
      setStatus(r.data);
    }).catch(() => {});
  }, []);

  return status;
}

export default function ComingSoonGate({ portalKey, children }) {
  const { t } = useLanguage();
  const status = usePortalStatus();
  const portalStatus = status[portalKey];

  if (portalStatus?.coming_soon) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 dark:from-slate-900 dark:to-slate-800 px-4" data-testid="coming-soon-gate">
        <div className="text-center max-w-md">
          <div className="w-20 h-20 mx-auto rounded-2xl bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center mb-6 shadow-lg">
            <Clock size={36} className="text-white" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-3">Uskoro dolazi</h1>
          <p className="text-gray-500 dark:text-gray-400 text-lg mb-6">
            {portalStatus.message || 'Ovaj portal je trenutno u pripremi. Molimo vas za strpljenje.'}
          </p>
          <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 bg-gray-900 dark:bg-white text-white dark:text-gray-900 rounded-xl font-medium hover:opacity-90 transition-opacity">
            <ArrowLeft size={18} /> Natrag na naslovnicu
          </Link>
        </div>
      </div>
    );
  }

  return children;
}
